module.exports = __webpack_public_path__ + "img/worksbot_img19112525.2403aef3.jpg";